import gaEvents from './ga-events'
import leftArrowImage from '@/components/common/Krpano/img/markers/arrows/left-arrow.png'
import leftFrontArrowImage from '@/components/common/Krpano/img/markers/arrows/left-front-arrow.png'
import rightFrontArrowImage from '@/components/common/Krpano/img/markers/arrows/right-front-arrow.png'
import rightArrowImage from '@/components/common/Krpano/img/markers/arrows/right-arrow.png'
import frontArrowImage from '@/components/common/Krpano/img/markers/arrows/front-arrow.png'
import upStairsArrowImage from '@/components/common/Krpano/img/markers/arrows/upstairs-arrow.png'
import downStairsArrowImage from '@/components/common/Krpano/img/markers/arrows/downstairs-arrow.png'
import pointImage from '@/components/common/Krpano/img/markers/point.png'
import teleportImage from '@/components/common/Krpano/img/markers/teleport.png'
import memoImage from '@/components/common/Krpano/img/markers/memo.png'
import tagImage from '@/components/common/Krpano/img/markers/tag.png'
import galleryImage from '@/components/common/Krpano/img/markers/gallery.png'
import webImage from '@/components/common/Krpano/img/markers/web.png'
import linkImage from '@/components/common/Krpano/img/markers/link.png'
import videoImage from '@/components/common/Krpano/img/markers/video.png'
import voiceImage from '@/components/common/Krpano/img/markers/voice.png'
import multitagImage from '@/components/common/Krpano/img/markers/multitag.png'
import stickerImage from '@/components/common/Krpano/img/markers/sticker.png'
import searchImage from '@/components/common/Krpano/img/markers/search.png'
import pdfImage from '@/components/common/Krpano/img/markers/pdf.png'
import {
  getIEVersion,
  isEmpty,
  isIframe,
  xhr
} from './utils'
import { resizeImage } from '@/utils/resize'
import { HOTSPOT_BASE_SIZE } from '@/api/constants'

export const iStagingUrl = 'https://www.istaging.com'

export const handleUrlRef = (to = { query: {} }, buildingId = '', callback = () => {}) => {
  const { ref } = to.query
  const { fullPath } = to
  switch (ref) {
    case 'facebook':
      gaEvents.sendEvent('Building', 'UrlClickedFromFacebook', buildingId)
      break
    case 'twitter':
      gaEvents.sendEvent('Building', 'UrlClickedFromTwitter', buildingId)
      break
    case 'linkedin':
      gaEvents.sendEvent('Building', 'UrlClickedFromLinkedin', buildingId)
      break
    case 'qrcode':
      gaEvents.sendEvent('Building', 'UrlClickedFromQRCode', buildingId)
      break
    case 'yc-fullscreen': // 目前永慶的開新視窗按鈕
      gaEvents.sendEvent('Building', 'UrlClickedFromYungChingFullscreenButton', buildingId)
      break
    case 'email':
      gaEvents.sendEvent('Building', 'UrlClickedFromEmail', buildingId)
      break
    case 'messenger':
      gaEvents.sendEvent('Building', 'UrlClickedFromMessenger', buildingId)
      break
    case 'line':
      gaEvents.sendEvent('Building', 'UrlClickedFromLine', buildingId)
      break
    case 'whatsapp':
      gaEvents.sendEvent('Building', 'UrlClickedFromWhatsApp', buildingId)
      break
    default:
      // eslint-disable-next-line no-case-declarations
      const value = ref === '' || ref === undefined ? 'Direct' : 'Other'
      gaEvents.sendEvent('Building', 'UrlClickedFrom' + value, buildingId)
      break
  }
  let newFullPath = fullPath.replace(/([?&])ref=[a-z-]*/, '') // remove ?ref=xxx or &ref=aaa-bbb
  if (fullPath.indexOf('?') <= -1 && fullPath.indexOf('&') > -1) {
    newFullPath = fullPath.replace('&', '?')
  }
  if (newFullPath !== fullPath) {
    callback(newFullPath)
  }
}

export const krpanoHelpers = {
  adjustKrpanoRendering (krpanoObj = null) {
    if (!krpanoObj) {
      return
    }
    krpanoObj.set('events[__threejs__].onviewchange', () => {
      // adjust krpano rendering
      if (krpanoObj.get('view.fisheye') !== 0.0) {
        // disable the fisheye distortion, ThreeJS objects can't be rendered with it
        krpanoObj.set('view.fisheye', 0.0)
      }
    }) // correct krpano view settings before the rendering
  }
}

export const genMarkerPosition = (deg) => {
  const position = {}
  const rad = deg * (Math.PI / 180)
  const x = -Math.sin(rad)
  const z = -Math.cos(rad)
  const y = Math.sin(rad)
  position.x = x * 200
  position.y = y * 200
  position.z = z * 200
  return position
}

export const coords3dTo2d = ({ x, y, z } = {}) => {
  const r = Math.sqrt(x * x + y * y + z * z)
  const ath = -Math.atan2(x, z) * 180 / Math.PI + 180
  const atv = -Math.asin(y / r) * 180 / Math.PI
  return { ath, atv }
}

export const coords2dTo3d = ({ ath, atv }) => {
  const x = -genMarkerPosition(ath).x
  const y = -genMarkerPosition(atv).y
  const z = genMarkerPosition(ath).z
  return { x, y, z }
}

export const isDevelopment = () => {
  return process.env.NODE_ENV === 'dev' ||
    process.env.NODE_ENV === 'test'
}

// if s contains control character, it will let krpano broken
export const xmlUrlString = (s = '') => {
  s = s.replace(/&/g, '&amp;')
  s = s.replace(/</g, '&lt;')
  s = s.replace(/>/g, '&gt;')
  s = s.replace(/'/g, '&apos;')
  s = s.replace(/"/g, '&quot;')
  return s
}

export const xmlString = (s = '') => {
  if (!s) {
    return s
  }
  s = window.escape(s)
  // prevent escaped symbols like %26 (&) becomes to null (krpano treat %N as argument)
  s = s.replace(/%/g, '%%')
  return s
}

export const krpanoEnterString = (string = '') => {
  return string.replace(/\n/g, '[br]')
}

export const krpanoAutoBlank = (string = '', n = 15, onlySingleLine = false) => { // n = max Latin-1 text in one line
  let stringAfterBlank
  stringAfterBlank = string.replace(/\[br\]/g, ' [br]')
  stringAfterBlank = stringAfterBlank.split(/[\n\t ]/g)
  stringAfterBlank = stringAfterBlank.map(word => {
    if (lengthInUtf8Bytes(word) >= (n * 2)) {
      for (let i = n; i <= word.length; i += (n + ' [br]'.length)) {
        if (onlySingleLine) {
          word = word.splice(i, 0, '... [br]')
        } else {
          word = word.splice(i, 0, ' [br]')
        }
      }
    }
    return word
  })
  stringAfterBlank = stringAfterBlank.join(' ')
  stringAfterBlank = stringAfterBlank.replace(/ \[br\]/g, '[br]')
  return stringAfterBlank
}

export const lengthInUtf8Bytes = (string = '') => {
  // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
  const m = encodeURIComponent(string).match(/%[89ABab]/g)
  return string.length + (m ? (m.length - 1) : 0)
}

export const setCorrectRotation = (value) => {
  // make rotation into -180 ~ 180
  while (value < -180 || value > 180) {
    if (value < -180) {
      value += 360
    }
    if (value > 180) {
      value -= 360
    }
  }

  return value
}

export const getParameterString = (routeQuery = {}) => {
  let parameter = ''
  const queries = Object.keys(routeQuery)
  if (queries && queries.length) {
    queries.forEach((query, index) => {
      index === 0
        ? parameter += '?'
        : parameter += '&'

      parameter += `${query}=${routeQuery[query]}`
    })
  }

  return parameter
}

export const imageIEHack = async (object = {}, keys = []) => {
  if (!isEmpty(object)) {
    await Promise.all(
      keys.map(async key => {
        if (object[key] && object[key].indexOf('getresizemapping') > -1) {
          const resp = await xhr(object[key], 'get')
          object[key] = JSON.parse(resp.target.response).url
          return resp
        }
      })
    )
  }
}

export const convertIndexFromUrlToArray = (index = 1, limit = Infinity) => {
  index = parseInt(index) // for user, panoramas is start from 1, not 0
  if (isNaN(index) || index <= 0) {
    index = 1
  }
  if (index > limit) {
    index = 0
  } else {
    index -= 1
  }
  return index
}

export const convertIndexFromArrayToUrl = (index = 0, limit = Infinity) => {
  index = parseInt(index) // for user, panoramas is start from 1, not 0
  if (isNaN(index) || index < 0) {
    index = 0
  }
  if (index > limit) {
    index = 1
  } else {
    index += 1
  }
  return index
}

export const getCorrectRotation = (value) => {
  // make rotation into -180 ~ 180
  while (value < -180 || value > 180) {
    if (value < -180) {
      value += 360
    }
    if (value > 180) {
      value -= 360
    }
  }
  return value
}

export const hotspotIcon = (marker = {}, useCustomIcon = false) => {
  if (useCustomIcon) {
    return `markerCustomIcon_${marker.objectId}`
  } else {
    switch (marker.type) {
      case 'point':
        switch (marker.iconType) {
          case 'leftArrow':
            return 'leftArrow'
          case 'leftFrontArrow':
            return 'leftFrontArrow'
          case 'rightFrontArrow':
            return 'rightFrontArrow'
          case 'rightArrow':
            return 'rightArrow'
          case 'frontArrow':
            return 'frontArrow'
          case 'upstairsArrow':
            return 'upstairsArrow'
          case 'downstairsArrow':
            return 'downstairsArrow'
          case 'point':
          default:
            return 'point'
        }
      case 'teleport':
        return 'teleport'
      case 'memo':
        return 'memo'
      case 'tag':
        return 'tag'
      case 'gallery':
        return 'gallery'
      case 'popup':
      case 'arMakerTag':
        switch (marker.iconType) {
          case 'link':
            return 'link'
          case 'video':
            return 'video'
          case 'web':
            return 'web'
          default:
            return 'web'
        }
      case 'pdf':
        return 'pdf'
      case 'narration':
        return 'narration'
      case 'multitag':
        return 'multitag'
      case 'sticker':
        return 'sticker'
      case 'search':
        return 'search'
      default:
    }
  }
}

export const getMarkerProfile = (marker) => {
  const iconTypeImage = {
    leftArrow: leftArrowImage,
    leftFrontArrow: leftFrontArrowImage,
    rightFrontArrow: rightFrontArrowImage,
    rightArrow: rightArrowImage,
    frontArrow: frontArrowImage,
    upstairsArrow: upStairsArrowImage,
    downstairsArrow: downStairsArrowImage,
    link: linkImage,
    video: videoImage,
    web: webImage
  }
  const markerImage = {
    point: pointImage,
    teleport: teleportImage,
    memo: memoImage,
    tag: tagImage,
    gallery: galleryImage,
    narration: voiceImage,
    popup: webImage,
    arMakerTag: webImage,
    multitag: multitagImage,
    sticker: stickerImage,
    search: searchImage,
    pdf: pdfImage
  }
  if (marker.photo) return marker.images ? marker.images[0] : marker.photo
  if (marker.useCustomIcon && marker.iconUrl) return marker.iconUrl
  if (marker.iconType && iconTypeImage[marker.iconType]) return iconTypeImage[marker.iconType]
  return markerImage[marker.type]
}

export const canLaunchPlanetView = () => !(getIEVersion() === 11 && isIframe())
export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export const parseEmailToFirebaseKey = (email = '') => {
  if (!email) {
    return email
  }
  return email.replace(/[@.#!$%^&*()]/gm, '')
}

export const generateCustomIconXml = (marker) => {
  if (marker.useCustomIcon && marker.iconUrl && /(\.gif)$/.test(marker.iconUrl)) {
    let opacity = isNaN(marker.opacity) ? 0.6 : (marker.opacity / 100)
    if (opacity * 100 <= 1) {
      opacity *= 100
    }

    const iconUrl = marker.disableResizing ? marker.iconUrl : resizeImage(marker.iconUrl)

    return `
      keep="true"
      renderer="css3d"
      onloaded="add_custom_icon('${xmlUrlString(iconUrl)}', ${HOTSPOT_BASE_SIZE}, ${HOTSPOT_BASE_SIZE}, ${opacity});"
    `
  } else {
    return ''
  }
}
